export const focusableButNoTabStop = -1;
export const indexNotSet = -1;
export const notFound = -1;
export const undefinedId = -1;
